export default __webpack_public_path__ + "static/media/apple.0092aec2.svg";